import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from "js-cookie";
// Register the dayjs locales app-wide so date formatting and the DateRangePicker
// calendar (via adapterLocale) can switch to any supported language.
import "dayjs/locale/en";
import "dayjs/locale/pt-br";
import "dayjs/locale/es";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import es from "./locales/es.json";
import { DEFAULT_LANGUAGE, LANGUAGE_KEY } from "./constants/i18n";

const resources = {
  en: { translation: en },
  pt: { translation: pt },
  es: { translation: es },
};

// Mirrors the SI Console / Admin Portal setup. The initial language comes from
// the shared LANGUAGE_KEY cookie (written on the parent ACT domain), so a
// language chosen in any ACT console applies here too. Missing keys fall back to
// English.
i18n.use(initReactI18next).init({
  resources,
  lng: Cookies.get(LANGUAGE_KEY) || DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
});

export default i18n;
